
import _ from 'lodash';

const namespaced = true;

const state = {
  recurrentInterventions: [],
  isFetchingRecurrentInterventions: false,
};

const mutations = {
  SET_RECURRENT_INTERVENTIONS(state, recurrentInterventions) {
    state.recurrentInterventions = recurrentInterventions;
  },
  SET_IS_FETCHING_RECURRENT_INTERVENTIONS(state, isFetchingRecurrentInterventions) {
    state.isFetchingRecurrentInterventions = isFetchingRecurrentInterventions;
  },
};

const actions = {
  async fetchRecurrentInterventions({ commit, dispatch, rootState }) {
    commit(`SET_IS_FETCHING_RECURRENT_INTERVENTIONS`, true);
    let recurrentInterventions = [];
    try {
      const makerId = rootState[`model/client`].company.id;
      [recurrentInterventions] = await Promise.all([
        dispatch(`model/inboxIntervention/fetchRecurrentInterventionsForMaker`, makerId, { root: true }),
        dispatch(`ui/mainLayout/fetchCountInboxInterventions`, null, { root: true }),
      ]);
    } catch (e) {} // eslint-disable-line

    commit(`SET_RECURRENT_INTERVENTIONS`, recurrentInterventions);
    commit(`SET_IS_FETCHING_RECURRENT_INTERVENTIONS`, false);
  },
};

const getters = {
  recurrentInterventions: state => _.orderBy(state.recurrentInterventions, [`createdAt`], [`desc`]),
  isFetchingRecurrentInterventions: state => state.isFetchingRecurrentInterventions,
};

export default {
  namespaced, state, mutations, actions, getters,
};
